import axios, { AxiosRequestConfig } from "axios";

export default {
  getIncident(id) {
    return axios.get(`/sp/Event/${id}`);
  },
  createIncident(data) {
    return axios.post("/sp/Event", data);
  },
  updateIncident(data, id) {
    return axios.put(`/sp/Event/${id}`, data);
  },
  getWaterSupplyIncident(id) {
    return axios.get(`/sp/Event/${id}/GetWaterSupplyIncident`);
  },
  getOrganizations(id?) {
    if (id) {
      return axios.get(`/sp/event/organizations?gridTypeId=${id}`, {});
    } else {
      return axios.get(`/sp/event/organizations`, {});
    }
    //return axios.get("/sp/Event/Organizations", {});
  },
  getEventHistory(id) {
    return axios.get(`/sp/Event/${id}/GetEventHistory`);
  },
  getStatusHistory(id) {
    return axios.get(`/sp/Event/${id}/GetStatusHistory`);
  },
  uploadDefectFile(values) {
    return axios.post("/sp/event/UploadDefectFromTemplate", values);
  },
  exportTemplate(gridTypeId) {
    const params: AxiosRequestConfig = {
      responseType: "arraybuffer",
      headers: { "Content-Type": "blob" },
    };
    return axios.get(`/sp/DefectReports/${gridTypeId}/ExportTemplate`, params);
  },
  exportExcel(request) {
    const params: AxiosRequestConfig = {
      responseType: "arraybuffer",
    };
    return axios.post("/sp/DefectReports/ExportDefectsToExcel", request, params);
  },
  exportExcelThread(request) {
    const params: AxiosRequestConfig = {
      responseType: "arraybuffer",
    };
    return axios.post("/sp/DefectReports/ExportDefectsToExcel/threaded", request, params);
  }
};
